// language=GraphQL
export const ALL_IMAGE_BLOCKS_QUERY = `query Query($withImage: Boolean = false) {
  imageBlocks: cmsImageBlocks {
    id
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    text
    fluid
  }
}`

// language=GraphQL
export const SINGLE_IMAGE_BLOCK_QUERY = `query Query($id: ID!, $withImage: Boolean = false) {
  imageBlock: cmsImageBlock(id: $id) {
    id
    image @include(if: $withImage) {
      id
      assetId
      publicId
      url
      resourceType
      format
      width
      height
      caption
      title
      description
    }
    text
    fluid
  }
}`

// language=GraphQL
export const CREATE_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsImageBlockInput, $withImage: Boolean = false) {
    imageBlock: createCmsImageBlock(input: $input) {
      id
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      text
      fluid
    }
  }`

// language=GraphQL
export const UPDATE_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsImageBlockInput, $withImage: Boolean = false) {
    imageBlock: updateCmsImageBlock(input: $input) {
      id
      image @include(if: $withImage) {
        id
        assetId
        publicId
        url
        resourceType
        format
        width
        height
        caption
        title
        description
      }
      text
      fluid
    }
  }`

// language=GraphQL
export const DELETE_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsImageBlockInput) {
    deleteCmsImageBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_IMAGE_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsImageBlockInput) {
    forceDeleteCmsImageBlock(input: $input) {
      success
    }
  }`
